import { useContext, useEffect, useState } from "react";
import style from "./gallery.module.css";
import { getGalleryDetailsApi } from "../../Api/services";
import config from "../../Api/config";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ReactPlayer from "react-player";
import { GlobalContext } from "../../context/Context";
import NavigationPath from "../../components/NavigationPath/NavigationPath";

const Gallery = () => {
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);
  const [galleryImage, setGalleryImage] = useState([]);
  const [galleryVideo, setGalleryVideo] = useState([]);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    galleryDetails();
    setNavigationPath([
      { name: "Home", path: "/" },
      { name: "Gallery", path: "/gallery" },
    ]);
  }, []);

  const galleryDetails = async () => {
    try {
      const response = await getGalleryDetailsApi();
      setGalleryImage(response?.gallery_image);
      setGalleryVideo(response?.gallery_video);
    } catch (error) {
      console.error("Error fetching gallery details:", error);
    } finally {
      setShowContent(true);
    }
  };

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
      slidesToSlide: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1201 },
      items: 4,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1200, min: 901 },
      items: 3,
      slidesToSlide: 1,
    },
    tablet2: {
      breakpoint: { max: 900, min: 721 },
      items: 2,
      slidesToSlide: 2,
    },
    mobile: {
      breakpoint: { max: 720, min: 601 },
      // items: 2,
      items: 1,
      slidesToSlide: 1,
    },
    mobile2: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  return (
    <>
      {showContent ? (
        <div>
          <div className={`${style.mainContainer}`}>
            <NavigationPath navigationPathArray={navigationPath} />

            {galleryImage?.length > 0 || galleryVideo?.length > 0 ? (
              <div className={style.pageTitle}>
                <div className={style.title}>
                  <span className={style.firstThree}>Gal</span>
                  <span className={style.gradientText}>lery</span>
                </div>
              </div>
            ) : (
              <p className={style.noDetailsAvailableText}>
                No details available
              </p>
            )}

            {galleryImage?.length > 0 ? (
              <div className={`${style.imageContainer}`}>
                {galleryImage?.map((item, index) => (
                  <div key={index} className={`${style.imageSubContainer}`}>
                    <img
                      className={`${style.image}`}
                      src={config.baseURL + item?.image}
                      alt=""
                    />
                  </div>
                ))}
              </div>
            ) : null}
            {galleryVideo?.length > 0 ? (
              <div className={`${style.videoContainer}`}>
                <Carousel responsive={responsive}>
                  {galleryVideo?.map((item, index) => {
                    return (
                      <div key={index}>
                        <ReactPlayer
                          className={`${style.video}`}
                          url={item?.video}
                          controls={true}
                          width={290}
                          height={175}
                        />
                      </div>
                    );
                  })}
                </Carousel>
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        <div className={style.loaderContent}>
          <img style={{ height: "30vh" }} src="adyant_loader.gif" />
        </div>
      )}
    </>
  );
};
export default Gallery;
